import { Routes as AppRoutes, BrowserRouter, Route } from "react-router-dom";
import { Home } from "../../Pages/Home";
import { ProtectedRoute } from "./ProtectedRoutes";
import { PublicRoute } from "./PublicRoutes";
import { LoginScreen } from "../LoginScreen";
import { RegisterDetail } from "../../Pages/RegisterDetail";
import { MapRegister } from "../../Pages/MapRegister";

export function Routes() {
    // const [viewMode] = useResponsiveContext();

    // const isMobile = viewMode === 'mobile';
    // let size = isMobile ? 158 : 220;

    return (
        <BrowserRouter>
            {/* <ScrollToTop /> */}
            <AppRoutes>
                {/* PUBLIC ROUTES */}
                <Route element={<PublicRoute />}>
                    <Route path="/" element={<LoginScreen />} />
                </Route>

                {/* PRIVATE ROUTES */}
                <Route element={<ProtectedRoute />}>
                    <Route path="/home/*" element={<Home />} />
                    <Route path="/home/register/registerDetail/:id" element={<Home />} />
                    {/* <Route path="/home/register/registerMap" element={<MapRegister />} /> */}
                </Route>

                {/* NO MATCH ROUTES */}
                {/* <Route path="*" element={<NoMatch />} /> */}
            </AppRoutes>
        </BrowserRouter>
    );
}